module.exports = __webpack_public_path__ + "static/img/noneImg.024b461.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/noneImg.png
// module id = 1H1j
// module chunks = 1